module.exports = __webpack_public_path__ + "static/1984-2-d40e6b36ca99d1195002ec633f31a33e.png";